module.exports = __webpack_public_path__ + "img/connect2.533c4d58.png";